<div class="row page-header">
    <div class="col-12">
        <h1>Company Quarters <small>Configure the dates that define company quarters</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Quarter'"
                            [binding]="'quarter'"
                            [width]="'*'"
                            [dataType]="'String'"
                            [format]="'d'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Year'"
                            [binding]="'year'"
                            [width]="'*'"
                            [dataType]="'String'"
                            [format]="'d'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Start Date'" [binding]="'startDate'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'End Date'" [binding]="'endDate'" [width]="'*'"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
